import { faTimes } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import IconButton from '~/common/mui/Buttons/MUIButton/MUIIconButton';
import palette from '~/theme/mui/palette';

type MUIButtonProps = React.ComponentProps<typeof IconButton>;

const ModalCloseButton = ({ sx, ...props }: Readonly<MUIButtonProps>) => {
  return (
    <IconButton
      aria-label="close"
      sx={{
        position: 'absolute',
        top: 16,
        right: 12,
        minWidth: '2.5rem',
        minHeight: '2.5rem',
        ...sx,
      }}
      {...props}
    >
      <FontAwesomeIcon
        style={{ fontSize: '1rem', color: palette.black }}
        icon={faTimes}
      />
    </IconButton>
  );
};

export default ModalCloseButton;
